<template lang="html">
  <div class="comment-item" @click="toDetail">
    <div class="avatar">
      <img :src="comment.user.photo | avatar(90, 90)" alt="" />
    </div>
    <div class="comment-user">
      <div class="user-name">
        <p>{{ name(comment.user.nickname) }}</p>
        <time>{{ timeFormat(comment.created_at * 1000) }}</time>
      </div>
      <div class="comment-content" :class="{ 'ommit-content': ommitContent }">
        {{ comment.content }}
      </div>
      <div class="server-person" v-if="comment.community_info && showServer">
        <userProfile
          cardName="bigcard"
          :showArrow="true"
          :canServe="true"
          :user="user(comment.community_info)"
          v-on:userDetail="getUserID"
        ></userProfile>
      </div>
      <div
        class="comment-imgs"
        v-if="comment.image_urls && comment.image_urls.length > 0"
      >
        <ul>
          <li
            v-for="(image, index) in comment.image_urls"
            @click="showImage(comment.image_urls, index)"
          >
            <img v-lazy="$$viewImageInCenter(image, 203, 203)" alt="" />
          </li>
        </ul>
      </div>
      <div class="comment-reply" v-if="showReply && replyData">
        <p>回复内容：</p>
        <div class="reply-cont">
          <div
            v-model="replyDetail"
            :class="{ 'limit-cont': limitReply.isLong }"
          >
            {{ replyData.content }}
          </div>
          <div
            class="arrow"
            v-if="limitReply.isShow"
            @click="showOrHideReply"
            :class="{ active: limitReply.isActive }"
          >
            <i class="iconfont icon-youjiantou"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userProfile from '@/components/user/profile'

export default {
  props: {
    comment: {
      type: Object,
      default() {
        return {}
      }
    },
    // 是否显示服务人员信息
    showServer: {
      type: Boolean,
      default: true
    }, // 是否显示服务人员信息
    isCzjSpu: {
      type: Boolean,
      default: false
    },
    // 评论文案是否要控制行数
    ommitContent: {
      type: Boolean,
      default: false
    },
    // 是否显示回复
    showReply: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      limitReply: {
        isLong: false,
        isShow: false,
        isActive: false
      }
    }
  },
  methods: {
    toDetail() {
      if (this.isCzjSpu) {
        const url = `//m.czj100.com/look/${this.comment.id}`
        location.href = `//app.czj100.com/webridge.html?url=${encodeURIComponent(
          url
        )}&uid=${this.$$cookie('uid')}&skey=${this.$$cookie('skey')}`
      }
    },
    user(obj) {
      let schedualAreas = []
      if (obj.service.length > 0) {
        schedualAreas = obj.service.map(ele => ({
          districtName: ele
        }))
      }
      let sourceName = '育儿顾问'
      if (obj.source === 'pop') {
        sourceName = '认证育儿师'
      } else if (obj.source === 'zj') {
        sourceName = '育儿专家'
      }
      return {
        is_del: obj.is_del,
        headPicUrl: obj.photo,
        uid: obj.uid,
        name: obj.name,
        score: obj.score,
        schedualAreas,
        startLevel: obj.startLevel,
        source: obj.source === 'hzw' ? 'gw' : obj.source,
        sourceName,
        startLevelName: obj.startLevelName
      }
    },
    name(val) {
      if (val.length > 1) {
        return `${val.charAt(0)}***${val.charAt(val.length - 1)}`
      } else {
        return `${val.charAt(0)}***`
      }
    },
    getUserID(user) {
      if (user.is_del === 0 || !user.uid) {
        // 离职
        return
      }
      if (this.$$isMp()) {
        return
      }
      this.$$tracker('100101', '20000', 21030)
      location.href = `/v/user/${user.uid}`
    },
    showImage(images, index) {
      //只能在评价列表点击
      if (this.$parent.$el.className === 'product-comment') return
      this.$store.commit('setPreviewImages', images)
      this.$router.push({ query: { preview: true, index } })
    },
    timeFormat(time) {
      const now = new Date()
      const now_y = now.getFullYear()
      const date = new Date(time)
      const date_y = date.getFullYear()
      if (now_y === date_y) {
        return this.$$dateFormat(time, 'MM.DD hh:mm')
      } else {
        return this.$$dateFormat(time, 'YY.MM.DD hh:mm')
      }
    },
    showOrHideReply() {
      if (this.limitReply.isLong) {
        // this.$$tracker('140101', '20000', '21117')
        this.limitReply.isLong = false
        this.limitReply.isActive = true
      } else {
        // this.$$tracker('140101', '20000', '21118')
        this.limitReply.isLong = true
        this.limitReply.isActive = false
      }
    }
  },
  computed: {
    replyDetail() {
      if (this.replyData && this.replyData.content.length > 32) {
        this.limitReply.isLong = true
        this.limitReply.isShow = true
      }
    },
    replyData() {
      let staff_uid = ''
      let replies = this.comment.replies
      if (this.comment.community_info) {
        staff_uid = this.comment.community_info.uid
      }
      if (replies && replies.length > 0) {
        replies = replies.filter(ele => ele.uid === staff_uid)
      }
      return replies && replies[0]
    }
  },
  components: {
    userProfile
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/mixin';

.comment-item {
  display: flex;
  padding: rem(15px) rem(20px);
  font-size: rem(28px);
  background: #fff;
  @include border(bottom);
  overflow: hidden;

  &::after {
    left: rem(100px);
  }
  &:last-of-type {
    &::after {
      display: none;
    }
  }

  .avatar {
    width: rem(60px);
    height: rem(60px);
    margin-right: rem(20px);
    border-radius: 50%;

    img {
      border-radius: 50%;
    }
  }
  .comment-user {
    flex: 1;
    padding-bottom: rem(15px);
  }
  .user-name {
    display: flex;
    color: #666;
    line-height: rem(60px);
    align-items: center;
    > p {
      flex: 1;
    }
    time {
      font-size: rem(24px);
    }
  }
  .comment-content {
    word-break: break-word;
    word-wrap: break-word;
    line-height: 1.5;
  }
  .ommit-content {
    display: -webkit-box;
    word-break: break-all;
    text-align: left;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    max-height: 4.5em;
    overflow: hidden;
  }
  .server-person {
    margin-top: rem(28px);
  }
  .comment-imgs {
    margin-top: rem(28px);

    ul {
      display: flex;
      height: rem(203px);
      overflow: hidden;
    }

    li {
      position: relative;
      width: 33.3333%;
      height: rem(203px);
      margin-right: rem(20px);

      img {
        // max-width: 100%;
        max-height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
  .comment-reply {
    display: flex;
    align-items: flex-start;
    margin-top: rem(30px);
    padding-top: rem(30px);
    @include border(top);

    &::before {
      right: rem(-20px);
    }

    > p {
      color: #999;
    }
    .reply-cont {
      flex: 1;
      word-break: break-all;
      text-align: left;

      .arrow {
        position: relative;
        text-align: center;
        // box-shadow: 0 -5px 3px rgba(255,255,255, .8)
      }
      .icon-youjiantou {
        color: #999;
        display: inline-block;
        transform: rotate(90deg);
        transition: transform 0.1s;
      }
      .active {
        box-shadow: none;
        .icon-youjiantou {
          transform: rotate(-90deg);
        }
      }
    }
    .limit-cont {
      // max-height: 2.6em;
      // line-height: 1.2;
      // box-sizing: content-box;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      /* autoprefixer: ignore next */
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
}
</style>
